/* ===========================================================
   Product Personalization
   Version 1.0
=========================================================== */

(function () {

    function initPersonalization() {

        const input = document.getElementById('personalized-message');
        const preview = document.getElementById('product-preview-text');

        if (!input || !preview) return;

        function updatePreview() {

            const value = input.value.trim();

            if (value === '') {

                preview.innerHTML = '';
                preview.classList.remove('active');

            } else {

                preview.textContent = value;
                preview.classList.add('active');

            }

        }

        input.removeEventListener('input', updatePreview);
        input.addEventListener('input', updatePreview);

        updatePreview();

    }

    document.addEventListener('DOMContentLoaded', initPersonalization);

    document.addEventListener('shopify:section:load', initPersonalization);

    document.addEventListener('variant:change', function () {

        setTimeout(initPersonalization, 100);

    });

})();